import React, { useEffect, useState } from 'react';
import api from '../../services/api';

const BASE = '/api/patients/recordatorios';

const fecha = (iso) => {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || '');
    return m ? `${m[3]}/${m[2]}/${m[1]}` : '—';
};

const Estado = ({ ok, children }) => (
    <span className="rc-pill" style={{ background: ok ? '#d1fae5' : ok === false ? '#fee2e2' : '#f3f4f6', color: ok ? '#065f46' : ok === false ? '#991b1b' : '#374151' }}>
        <i className={`bi ${ok ? 'bi-check-circle-fill' : ok === false ? 'bi-x-circle-fill' : 'bi-dash-circle'} me-1`}></i>{children}
    </span>
);

// Configuración y pruebas de los recordatorios de control visual por correo (Resend).
const RecordatoriosCorreo = () => {
    const [config, setConfig] = useState(null);
    const [resend, setResend] = useState(null);
    const [guardando, setGuardando] = useState(false);
    const [aviso, setAviso] = useState(null);

    const [tipo, setTipo] = useState('previo');
    const [sucursalPreview, setSucursalPreview] = useState('ambas');
    const [preview, setPreview] = useState(null);
    const [emailPrueba, setEmailPrueba] = useState('');
    const [enviando, setEnviando] = useState(false);

    const [proximos, setProximos] = useState(null);
    const [historial, setHistorial] = useState([]);

    const mostrarAviso = (texto, ok = true) => {
        setAviso({ texto, ok });
        setTimeout(() => setAviso(null), 6000);
    };

    const cargar = async () => {
        try {
            const [c, p, h] = await Promise.all([
                api.get(`${BASE}/configuracion/`),
                api.get(`${BASE}/proximos/`),
                api.get(`${BASE}/historial/`)
            ]);
            setConfig(c.data.config);
            setResend(c.data.resend);
            setProximos(p.data);
            setHistorial(h.data);
        } catch (e) {
            mostrarAviso('No se pudo cargar la configuración de recordatorios.', false);
        }
    };

    const cargarPreview = async (t = tipo, s = sucursalPreview) => {
        try {
            const { data } = await api.post(`${BASE}/vista-previa/`, { tipo: t, sucursal: s });
            setPreview(data);
        } catch (e) {
            setPreview(null);
        }
    };

    useEffect(() => { cargar(); cargarPreview('previo', 'ambas'); }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const cambiar = (campo, valor) => setConfig(prev => ({ ...prev, [campo]: valor }));

    const guardar = async () => {
        setGuardando(true);
        try {
            const { data } = await api.patch(`${BASE}/configuracion/`, config);
            setConfig(data.config);
            setResend(data.resend);
            mostrarAviso('Configuración guardada.');
            cargarPreview(tipo, sucursalPreview);
            const p = await api.get(`${BASE}/proximos/`);
            setProximos(p.data);
        } catch (e) {
            const err = e.response?.data;
            mostrarAviso(err ? Object.values(err).flat().join(' ') : 'No se pudo guardar.', false);
        }
        setGuardando(false);
    };

    const enviarPrueba = async () => {
        setEnviando(true);
        try {
            const { data } = await api.post(`${BASE}/probar/`, { email: emailPrueba, tipo, sucursal: sucursalPreview });
            mostrarAviso(data.detail);
        } catch (e) {
            mostrarAviso(e.response?.data?.detail || 'No se pudo enviar el correo de prueba.', false);
        }
        setEnviando(false);
    };

    if (!config) {
        return <div className="rc-page"><p className="text-muted">Cargando...</p></div>;
    }

    return (
        <div className="rc-page">
            <style>{`
                .rc-page { padding: 24px; max-width: 1200px; margin: 0 auto; }
                .rc-page h2 { font-weight: 800; color: #111827; margin: 0; }
                .rc-sub { color: #6b7280; margin: 4px 0 20px; }
                .rc-grid { display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 1.15fr); gap: 20px; align-items: start; }
                .rc-card { background: #fff; border: 1px solid #e5e7eb; border-radius: 14px; padding: 18px 20px; margin-bottom: 20px; }
                .rc-card h5 { margin: 0 0 14px; font-size: 0.82rem; font-weight: 800; letter-spacing: 0.06em; text-transform: uppercase; color: #6b7280; }
                .rc-field { margin-bottom: 12px; }
                .rc-field label { display: block; font-size: 0.8rem; font-weight: 600; color: #374151; margin-bottom: 4px; }
                .rc-field input[type=text], .rc-field input[type=email], .rc-field input[type=number] { width: 100%; padding: 8px 10px; border: 1px solid #d1d5db; border-radius: 8px; font-size: 0.92rem; box-sizing: border-box; }
                .rc-row { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
                .rc-check { display: flex; align-items: center; gap: 8px; font-size: 0.9rem; margin-bottom: 10px; cursor: pointer; }
                .rc-check input { width: 18px; height: 18px; }
                .rc-btn { display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px; border-radius: 8px; font-weight: 700; font-size: 0.88rem; cursor: pointer; border: 1.5px solid #111827; background: #111827; color: #fff; }
                .rc-btn:disabled { opacity: 0.6; cursor: default; }
                .rc-btn.rc-sec { background: #fff; color: #111827; }
                .rc-pill { display: inline-flex; align-items: center; padding: 3px 10px; border-radius: 999px; font-size: 0.8rem; font-weight: 700; }
                .rc-estado { display: flex; flex-direction: column; gap: 8px; font-size: 0.9rem; }
                .rc-estado > div { display: flex; justify-content: space-between; gap: 10px; align-items: center; }
                .rc-tabs { display: inline-flex; background: #f3f4f6; border-radius: 8px; padding: 3px; margin-bottom: 10px; }
                .rc-tabs button { border: none; background: transparent; padding: 6px 12px; border-radius: 6px; font-weight: 600; font-size: 0.82rem; cursor: pointer; color: #374151; }
                .rc-tabs button.on { background: #fff; color: #111827; box-shadow: 0 1px 3px rgba(0,0,0,0.1); }
                .rc-asunto { font-size: 0.85rem; color: #374151; margin-bottom: 8px; }
                .rc-frame { width: 100%; height: 470px; border: 1px solid #e5e7eb; border-radius: 10px; background: #f3f4f6; }
                .rc-tabla { width: 100%; border-collapse: collapse; font-size: 0.85rem; }
                .rc-tabla th { text-align: left; color: #6b7280; font-weight: 600; font-size: 0.75rem; padding: 6px 8px; border-bottom: 1px solid #e5e7eb; }
                .rc-tabla td { padding: 7px 8px; border-bottom: 1px solid #f3f4f6; vertical-align: top; }
                .rc-scroll { max-height: 340px; overflow-y: auto; }
                .rc-aviso { position: fixed; right: 20px; bottom: 20px; z-index: 1060; padding: 12px 18px; border-radius: 10px; font-weight: 600; box-shadow: 0 10px 25px rgba(0,0,0,0.15); max-width: 420px; }
                @media (max-width: 900px) { .rc-grid { grid-template-columns: 1fr; } .rc-row { grid-template-columns: 1fr; } }
            `}</style>

            <h2><i className="bi bi-envelope-paper me-2"></i>Recordatorios por correo</h2>
            <p className="rc-sub">Avisos automáticos a los pacientes antes de su control visual y felicitación con descuento el día de su cumpleaños. Aquí puede configurarlos, ver cómo llega el correo y enviar pruebas.</p>

            <div className="rc-grid">
                <div>
                    <div className="rc-card">
                        <h5>Estado del servicio</h5>
                        <div className="rc-estado">
                            <div><span>Clave de Resend</span><Estado ok={resend?.clave_configurada && resend?.clave_valida !== false}>{resend?.clave_configurada ? (resend?.clave_valida === false ? 'Inválida' : 'Configurada') : 'Falta'}</Estado></div>
                            <div><span>Remitente</span><span style={{ fontWeight: 600, overflowWrap: 'anywhere', textAlign: 'right' }}>{resend?.remitente || '—'}</span></div>
                            <div><span>Dominio {resend?.dominio}</span><Estado ok={resend?.dominio_verificado}>{resend?.dominio_verificado ? 'Verificado' : resend?.dominio_verificado === false ? 'Sin verificar' : 'No comprobado'}</Estado></div>
                            <div><span>Envío automático</span><Estado ok={config.activo}>{config.activo ? `Activo, a las ${String(config.hora_envio).padStart(2, '0')}:00` : 'Pausado'}</Estado></div>
                            <div><span>Felicitación de cumpleaños</span><Estado ok={config.activo && config.cumpleanos_activo}>{config.activo && config.cumpleanos_activo ? `Activa, ${config.cumpleanos_descuento}% de descuento` : 'Pausada'}</Estado></div>
                            <div style={{ color: '#6b7280', fontSize: '0.82rem' }}>{resend?.mensaje}</div>
                        </div>
                    </div>

                    <div className="rc-card">
                        <h5>Configuración</h5>
                        <label className="rc-check">
                            <input type="checkbox" checked={config.activo} onChange={e => cambiar('activo', e.target.checked)} />
                            Enviar recordatorios automáticamente
                        </label>
                        <div className="rc-row">
                            <div className="rc-field">
                                <label>Hora del envío diario</label>
                                <input type="number" min="0" max="23" value={config.hora_envio} onChange={e => cambiar('hora_envio', parseInt(e.target.value || '0', 10))} />
                            </div>
                            <div className="rc-field">
                                <label>Primer aviso (días antes)</label>
                                <input type="number" min="1" max="30" value={config.dias_previo} onChange={e => cambiar('dias_previo', parseInt(e.target.value || '1', 10))} />
                            </div>
                        </div>
                        <label className="rc-check">
                            <input type="checkbox" checked={config.enviar_dia_control} onChange={e => cambiar('enviar_dia_control', e.target.checked)} />
                            Enviar también un aviso el día del control
                        </label>
                        <div className="rc-row">
                            <div className="rc-field">
                                <label>Nombre de la óptica</label>
                                <input type="text" value={config.nombre_clinica} onChange={e => cambiar('nombre_clinica', e.target.value)} />
                            </div>
                            <div className="rc-field">
                                <label>Responder a (correo de la óptica)</label>
                                <input type="email" value={config.responder_a} onChange={e => cambiar('responder_a', e.target.value)} placeholder="optica@ejemplo.com" />
                            </div>
                        </div>

                        {/* Sucursal Norte */}
                        <div style={{ marginTop: 10, marginBottom: 12, padding: '12px 14px', background: '#f9fafb', borderRadius: 10, border: '1px solid #e5e7eb' }}>
                            <div style={{ fontWeight: 800, fontSize: '0.84rem', color: '#111827', marginBottom: 8, display: 'flex', alignItems: 'center', gap: 6 }}>
                                <span>📍 SUCURSAL NORTE (MATRIZ)</span>
                            </div>
                            <div className="rc-row">
                                <div className="rc-field" style={{ marginBottom: 4 }}>
                                    <label>Teléfono / WhatsApp</label>
                                    <input type="text" value={config.telefono || ''} onChange={e => cambiar('telefono', e.target.value)} placeholder="0962602999" />
                                </div>
                                <div className="rc-field" style={{ marginBottom: 4 }}>
                                    <label>Dirección</label>
                                    <input type="text" value={config.direccion || ''} onChange={e => cambiar('direccion', e.target.value)} placeholder="Entre Arellano y Ayacucho" />
                                </div>
                            </div>
                        </div>

                        {/* Sucursal Sur */}
                        <div style={{ marginBottom: 16, padding: '12px 14px', background: '#f9fafb', borderRadius: 10, border: '1px solid #e5e7eb' }}>
                            <div style={{ fontWeight: 800, fontSize: '0.84rem', color: '#111827', marginBottom: 8, display: 'flex', alignItems: 'center', gap: 6 }}>
                                <span>📍 SUCURSAL SUR</span>
                            </div>
                            <div className="rc-row">
                                <div className="rc-field" style={{ marginBottom: 4 }}>
                                    <label>Teléfono / WhatsApp</label>
                                    <input type="text" value={config.telefono_sur || ''} onChange={e => cambiar('telefono_sur', e.target.value)} placeholder="0993387008" />
                                </div>
                                <div className="rc-field" style={{ marginBottom: 4 }}>
                                    <label>Dirección</label>
                                    <input type="text" value={config.direccion_sur || ''} onChange={e => cambiar('direccion_sur', e.target.value)} placeholder="AV. VEINTIMILLA Y CAMILO PONCE" />
                                </div>
                            </div>
                        </div>

                        {/* Cumpleaños */}
                        <div style={{ marginBottom: 16, padding: '12px 14px', background: '#fffbeb', borderRadius: 10, border: '1px solid #fde68a' }}>
                            <div style={{ fontWeight: 800, fontSize: '0.84rem', color: '#111827', marginBottom: 8 }}>🎂 FELICITACIÓN DE CUMPLEAÑOS</div>
                            <label className="rc-check">
                                <input type="checkbox" checked={config.cumpleanos_activo} onChange={e => cambiar('cumpleanos_activo', e.target.checked)} />
                                Enviar felicitación el día del cumpleaños
                            </label>
                            <div className="rc-row">
                                <div className="rc-field" style={{ marginBottom: 4 }}>
                                    <label>Descuento de regalo (%)</label>
                                    <input type="number" min="1" max="100" value={config.cumpleanos_descuento} onChange={e => cambiar('cumpleanos_descuento', parseInt(e.target.value || '0', 10))} />
                                </div>
                                <div className="rc-field" style={{ marginBottom: 4 }}>
                                    <label>Vigencia del descuento (días)</label>
                                    <input type="number" min="1" max="365" value={config.cumpleanos_vigencia_dias} onChange={e => cambiar('cumpleanos_vigencia_dias', parseInt(e.target.value || '0', 10))} />
                                </div>
                            </div>
                        </div>

                        <button className="rc-btn" onClick={guardar} disabled={guardando}>
                            <i className="bi bi-save"></i>{guardando ? 'Guardando...' : 'Guardar configuración'}
                        </button>
                    </div>
                </div>

                <div>
                    <div className="rc-card">
                        <h5>Vista previa y prueba</h5>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: 12 }}>
                            <div className="rc-tabs">
                                <button className={tipo === 'previo' ? 'on' : ''} onClick={() => { setTipo('previo'); cargarPreview('previo', sucursalPreview); }}>Aviso {config.dias_previo} días antes</button>
                                <button className={tipo === 'dia' ? 'on' : ''} onClick={() => { setTipo('dia'); cargarPreview('dia', sucursalPreview); }}>Aviso el día del control</button>
                                <button className={tipo === 'cumpleanos' ? 'on' : ''} onClick={() => { setTipo('cumpleanos'); cargarPreview('cumpleanos', sucursalPreview); }}>🎂 Cumpleaños</button>
                            </div>
                            <div className="rc-tabs">
                                <button className={sucursalPreview === 'ambas' ? 'on' : ''} onClick={() => { setSucursalPreview('ambas'); cargarPreview(tipo, 'ambas'); }}>Ambas sucursales</button>
                                <button className={sucursalPreview === 'norte' ? 'on' : ''} onClick={() => { setSucursalPreview('norte'); cargarPreview(tipo, 'norte'); }}>Solo Norte</button>
                                <button className={sucursalPreview === 'sur' ? 'on' : ''} onClick={() => { setSucursalPreview('sur'); cargarPreview(tipo, 'sur'); }}>Solo Sur</button>
                            </div>
                        </div>
                        {preview && (
                            <>
                                <div className="rc-asunto"><strong>Asunto:</strong> {preview.asunto}</div>
                                <iframe title="Vista previa del correo" className="rc-frame" srcDoc={preview.html} sandbox="" />
                            </>
                        )}
                        <div className="rc-field" style={{ marginTop: '14px' }}>
                            <label>Enviar este correo de prueba a</label>
                            <div style={{ display: 'flex', gap: '8px' }}>
                                <input type="email" value={emailPrueba} onChange={e => setEmailPrueba(e.target.value)} placeholder="su.correo@ejemplo.com" />
                                <button className="rc-btn" onClick={enviarPrueba} disabled={enviando || !emailPrueba}>
                                    <i className="bi bi-send"></i>{enviando ? 'Enviando...' : 'Enviar'}
                                </button>
                            </div>
                            <div className="text-muted" style={{ fontSize: '0.78rem', marginTop: '4px' }}>
                                Llega con "[PRUEBA]" en el asunto y no queda registrado como recordatorio de un paciente.
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="rc-card">
                <h5>Se enviarán en la próxima pasada ({proximos?.pendientes_hoy?.length || 0})</h5>
                {proximos?.sin_correo_proximos_30_dias > 0 && (
                    <div style={{ background: '#fffbeb', border: '1px solid #fde68a', color: '#92400e', borderRadius: 8, padding: '8px 12px', fontSize: '0.85rem', marginBottom: 10 }}>
                        <i className="bi bi-exclamation-triangle me-1"></i>
                        {proximos.sin_correo_proximos_30_dias} paciente(s) con control en los próximos 30 días no tienen correo registrado y no recibirán aviso.
                    </div>
                )}
                {proximos?.pendientes_hoy?.length ? (
                    <div className="rc-scroll">
                        <table className="rc-tabla">
                            <thead><tr><th>Paciente</th><th>Correo</th><th>Control</th><th>Aviso</th></tr></thead>
                            <tbody>
                                {proximos.pendientes_hoy.map((p, i) => (
                                    <tr key={i}><td>{p.paciente}</td><td>{p.email}</td><td>{fecha(p.fecha_control)}</td><td>{p.tipo}</td></tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : <div className="text-muted">No hay recordatorios pendientes por ahora.</div>}
            </div>

            <div className="rc-card">
                <h5>Historial de envíos</h5>
                {historial.length ? (
                    <div className="rc-scroll">
                        <table className="rc-tabla">
                            <thead><tr><th>Fecha</th><th>Paciente</th><th>Correo</th><th>Tipo</th><th>Control</th><th>Estado</th></tr></thead>
                            <tbody>
                                {historial.map(h => (
                                    <tr key={h.id}>
                                        <td>{new Date(h.enviado_en).toLocaleString()}</td>
                                        <td>{h.paciente}</td>
                                        <td>{h.email}</td>
                                        <td>{h.tipo}</td>
                                        <td>{fecha(h.fecha_control)}</td>
                                        <td>
                                            <Estado ok={h.estado === 'enviado'}>{h.estado === 'enviado' ? 'Enviado' : 'Error'}</Estado>
                                            {h.error && <div style={{ color: '#991b1b', fontSize: '0.75rem', marginTop: 2 }}>{h.error}</div>}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : <div className="text-muted">Todavía no se ha enviado ningún correo.</div>}
            </div>

            {aviso && (
                <div className="rc-aviso" style={{ background: aviso.ok ? '#065f46' : '#991b1b', color: '#fff' }}>{aviso.texto}</div>
            )}
        </div>
    );
};

export default RecordatoriosCorreo;
